import angular from 'angular';
import './resource';

const module = angular.module('whyline.resources.tags-groups', [
	'whyline.resources.resource',
	'ngFileUpload',
]);

const TagsGroupsFactory = (
	Resource,
	$http,
	$timeout,
	API_URL,
	Upload,
) => {
	/* @ngInject */
	// API REST Resource Name
	const _type = 'tags-groups?organizationId';

	const _schema = {
		_id: String,
		organizationId: String,
		name: String,
		order: Number,
		tags: [{
			placeIds: [String],
			tagName: String
		}]
	};

	const TagsGroups = function (data) {
		angular.forEach(_schema, (prop, key) => {
			this[key] = prop.default;
		});

		angular.forEach(data, (prop, key) => {
			this[key] = prop;
		});

		this.enable = enabled => {
			const promise = $http.put(`${API_URL}tags-groups/${this._id}/enabled?organizationId`, {
				enabled,
			});
			promise.then(response => {
				const item = response.data;

				$timeout(() => {
					TagsGroups.UpdateCache(item._id, item);
				});

				return TagsGroups.GetOneFromCache('_id', this._id);
			});

			return promise;
		};
	};

	TagsGroups.prototype = new Resource(_type, _schema, TagsGroups);

	Resource.Extend(_type, TagsGroups);

	TagsGroups.FetchAll = () => {
		const url = `${API_URL}${_type}`;

		return $http
			.get(url)
			.then(response => {
				return response.data;
			});
	}

	TagsGroups.Update = async (tagGroupUpdated, tagGroupId) => {
		const url = `${API_URL}tags-groups/${tagGroupId}?organizationId`;

		return $http({
			method: 'PUT',
			url: url,
			data: tagGroupUpdated,
		}).then(response => {
			return Promise.resolve(response);
		});
	};

	TagsGroups.UpdateTags = async (tagGroupId, tags) => {
		const url = `${API_URL}tags-groups/${tagGroupId}/tags?organizationId`;

		return $http({
			method: 'PUT',
			url: url,
			data: { tags: tags },
		}).then(response => {
			return response;
		});
	};

	TagsGroups.Sync = (rows, action, extension) => {
		const configuration = {
			url: `${API_URL}tags-groups/sync?organizationId?action=${action}&extension=${extension}`,
			method: 'POST',
			file: Upload.jsonBlob(rows),
		};

		return Upload.upload(configuration);
	};

	// One minute
	const validityTime = 1 * 60 * 1000;
	TagsGroups.InitCache(validityTime);

	return TagsGroups;
}

module.exports = module.factory('TagsGroups', TagsGroupsFactory);
